<template>
  <div>
    <div class="tac py-5 mb-4">
      <h3 class="mb-4">
        {{lg('',{
          en: 'Stake LP tokens to earn LAVA',
          zh: '存储 LP token 赚取 LAVA',
        })}}
      </h3>

      <div>
        <div class="ui-tabset" style="max-width: 250px;">
          <span 
            :class="['tab size-big',{'on': on_tab == 'active'}]"
            @click="on_tab = 'active'"
          >
            {{lg('',{
              en: 'Active',
              zh: '进行中',
            })}}
          </span>
          <span 
            :class="['tab size-big',{'on': on_tab == 'inactive'}]"
            @click="on_tab = 'inactive'"
          >
            {{lg('',{
              en: 'Inactive',
              zh: '已结束',
            })}}
          </span>
        </div>
      </div>

      <div class="tac mt-4 d-flex align-items-center justify-content-center">
        <span  
          @click="status_view_staked = !status_view_staked" 
          :class="['btn-switch no-dark-mode bg-light-c',{'on-right green': status_view_staked}]"
          style="width: 40px;"
          >
          <span class="switch-thumb"></span>
        </span>
        <span class="ml-2">
          {{lg('',{
            en: 'Staked Only',
            zh: '仅看有质押',
          })}}
        </span>
      </div>
    </div>


    <div class="container" style="max-width: 900px;">

      <div v-if="on_tab == 'active'" class="list-pool-cards mt-5">
        <div 
          class="item mb-4"
          v-for="item of main_list_pool"
          :key="item.id"
          >
          <poolCard 
            :item="item"
            :cfg_view_staked="status_view_staked"
          />
        </div>
      </div>

      <div v-if="on_tab == 'inactive'" class="list-pool-cards mt-5">
        <div 
          class="item mb-4"
          v-for="item of main_list_pool_inactive"
          :key="item.id"
          >
          <poolCard 
            :item="item"
            :cfg_view_staked="status_view_staked"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import main_list_pool from '@/data/main_list_pool.js'
import main_list_pool_inactive from '@/data/main_list_pool_inactive.js'
import poolCard from './poolCard.vue'

export default {
  name: 'pool',
  components: {
    poolCard,
  },
  props: [],
  data() {
    return {
      on_tab: 'active',
      main_list_pool_inactive: main_list_pool_inactive,
      main_list_pool: main_list_pool,

      status_view_staked: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    autoSetTab(){
      let v = this
      if( v.$route.query.tab ){
        v.on_tab = v.$route.query.tab
      }
    },
  },
  created() {
    this.autoSetTab()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .list-pool-cards{
    display: flex;
    flex-wrap: wrap;

    .item{
      &:empty{
        display: none;
      }
    }

    // mobile
    @media(max-width: 788px){
      margin: 0 10px;
      .item{
        // width: 100%;
        width: 50%;
      }
    }

    // pc
    @media(min-width: 788px){
      margin: 0 50px;
      .item{
        width: 33%;
      }
    }
  }
</style>